import React, { useState, useEffect, useContext, useCallback} from 'react'
import { NavigationContext } from '../../../context/navigation-context'
import { NotificationManager } from "react-notifications";
import { LangContext } from '../../../context/lang-context'
import { Link } from 'react-router-dom'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import CategoryForm from '../../../components/Modals/CategoryForm'
import sampleProduct from '../../../assets/images/sample-product.svg'
import { API_URL } from '../../../config/config'
import CategoriesTable from './components/CategoriesTable'
import SearchFilter from './../../../components/Filter/SearchFilter'

const Categories = () => {
  const { fetchMssqlApi } = useFetch()
  const { setHeaderData } = useContext(NavigationContext)
  const { TRL_Pack } = useContext(LangContext)
  const [form, setForm] = useState(null);
  const [categories, setCategories] = useState([])

  const defaultFilter = {
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    categoryId: null,
    categoryName: ""
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState();

  const sortDefaults = {
    Name: "ASC",
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    const curDir = (curDirRaw || "").toUpperCase();
    let sortBy;
    let sortByName=""
    if (curField !== field) {sortBy = `${field}|DESC`;
    } else if (curDir === "DESC") {sortBy = `${field}|ASC`;
    } else if (curDir === "ASC") {sortBy = "none";
    } else sortBy = `${field}|DESC`;
    const next = { ...filter, sortBy, page: 1 };
    setFilter(next);
    search(next, settingsFilter.rowsPerPage, 1, true);
  };

  const search = (f) => {
    fetchMssqlApi(
      'categories',
      {
        method: "POST",
        showLoader: true,
        hideNotification: true,
        data: {
          categoryId: f?.categoryId,
          sortBy: f?.sortBy
        }
      },
      (categories) => setCategories(categories)
    )
  }

  const submitCategory = (evt) => {
    evt.preventDefault();

    const { name, image, existingImage, imageRemoved, color } = evt.target.elements;
    const formData = new FormData();

    formData.append("Name", name.value);
    formData.append("categoryId", form);
    formData.append("Color", color.value);

    if (image.files[0]) {
      formData.append("Image", image.files[0]);
    } else if (form !== "new" && imageRemoved?.value !== "1" && existingImage?.value) {
      formData.append("Image", existingImage.value);
    }

    const isEdit = form !== "new";
    const method = isEdit ? "PUT" : "POST";

    fetchMssqlApi(
      "category",
      { method, data: formData, hideNotification: true },
      () => {
        search(filter);
        setForm(null);
        NotificationManager.success("Zapisano", "OK", 2000);
      },
      (err) => {
        const status = err?.response?.status;
        const msg = err?.response?.data?.message || err?.message || "Błąd";

        if (status === 409) {
          NotificationManager.error(msg, "Konflikt", 3000);
          return;
        }
        if (status === 403) {
          NotificationManager.error(msg, "Brak uprawnień", 3000);
          return;
        }

        NotificationManager.error(msg, "Błąd", 3000);
      }
    );
  };

  const deleteCategory = categoryId => {
    fetchMssqlApi(`category/${categoryId}`, { method: 'DELETE' }, () => {search(filter); setForm(null)})
  }

  useEffect(() => {
    setHeaderData({ text: TRL_Pack.navigation.categories,
      className: "pe-none"
     });
    if (process.env.REACT_APP_LOCAL_DB === "true") {
      search(defaultFilter);
    }
  }, []);

  const handleSearchFilterChange = useCallback((f) => {
    setFilter(prev =>
      JSON.stringify(prev || {}) === JSON.stringify(f || {}) ? prev : f
    );
  }, []);

  return (
    <div>
      <ul className="nav nav-tabs machine-tabs mb-1">
        <li className="nav-item">
          <Link to="/products">
            <button className={`nav-link btn`} tabIndex="0">
              Produkty
            </button>
          </Link>
        </li>
        {process.env.REACT_APP_LOCAL_DB === "false" && (
          <li className="nav-item">
            <Link to="/recipes">
              <button className={`nav-link btn`} tabIndex="0">
                Receptury
              </button>
            </Link>
          </li>
        )}
        <li className="nav-item">
          <Link to="/categories">
            <button className={`nav-link btn active`} tabIndex="0">
              Kategorie
            </button>
          </Link>
        </li>
        {process.env.REACT_APP_LOCAL_DB === "false" && (
        <li className="nav-item">
          <Link to="/deposits">
            <button className={`nav-link btn`} tabIndex="0">
              Kaucje
            </button>
          </Link>
        </li>
        )}
      </ul>
      {process.env.REACT_APP_LOCAL_DB === "false" && (
        <SearchFilter
          filterName={"category"}
          defaultFilter={defaultFilter}
          searchFilter={filter}
          onFilterChange={handleSearchFilterChange}
          onSettingsChange={(s) => setSettingsFilter(s)}
          search={search}
          totalCount={categories.length}
          forNow
        />
      )}
      <CategoriesTable
        categories={categories}
        sampleProduct={sampleProduct}
        API_URL={API_URL}
        setForm={setForm}
        sortBy={filter.sortBy}
        handleHeaderSort={handleHeaderSort}
      />
      {form && (
        <CategoryForm
          API_URL={API_URL}
          categoryData={form !== "new" ? categories.find(category => category.CategoryId === form) : null}
          handleSubmit={submitCategory}
          handleDelete={deleteCategory}
          form={form}
          setForm={setForm}
        />
      )}
    </div>
  )
}

export default Categories;